const key = (section) => `practice_session::${section}`;

export function savePracticeSession(section, { questions, answers, flagged, currentIdx }) {
  try {
    localStorage.setItem(key(section), JSON.stringify({ questions, answers, flagged, currentIdx, savedAt: Date.now() }));
  } catch {}
}

export function loadPracticeSession(section) {
  try {
    const raw = localStorage.getItem(key(section));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function clearPracticeSession(section) {
  try { localStorage.removeItem(key(section)); } catch {}
}
